import { render, staticRenderFns } from "./brandBottom.vue?vue&type=template&id=1262769f&scoped=true"
import script from "./brandBottom.vue?vue&type=script&lang=js"
export * from "./brandBottom.vue?vue&type=script&lang=js"
import style0 from "./brandBottom.vue?vue&type=style&index=0&id=1262769f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1262769f",
  null
  
)

export default component.exports